// extracted by mini-css-extract-plugin
export default {"withGradient":"email-form_withGradient__zaXsH"};